var app = angular.module('leonardo');

var BreadcrumbConfig = function($breadcrumbProvider) {
  $breadcrumbProvider.setOptions({
    includeAbstract: true,
    templateUrl: 'views/templates/breadcrumb.html'
  });
};

app.config(['$breadcrumbProvider', BreadcrumbConfig]);
